/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#scroll-top[_ngcontent-%COMP%]{position:fixed;width:41px;height:41px;left:0;bottom:0;font-size:13px;line-height:41px;text-align:center;color:#b3b2b2;background:#000;z-index:99999;opacity:.5}"];
export { styles as styles };
